<template>
  <div>
    <div v-if="!showDetails">
      <div v-if="exams.length > 0">
        <app-exam v-for="index in exams.length" :key="index" :index="index - 1" :exam="exams[index - 1]"
          :showDetails="false" @clicked="onClickClass">
        </app-exam>
      </div>
      <div v-else style="margin: 20px">
        {{ tableText }}
      </div>
    </div>
    <div v-else>
      <template v-if="isMobile">
        <app-exam :index="selectedCourse" :exam="exams[selectedCourse]" :showDetails="true" @download="callDownload">
        </app-exam>
        <div class="courses">
          <v-card v-for="key in courses.length" :key="key" :index="key - 1">
            <v-card-title class="info-detail">
              <div class="text-center">
                {{ courses[key - 1].TitleName }} -
                {{ courses[key - 1].PayehName }}
              </div>
            </v-card-title>
            <div>
              <app-row icon="book" title="کد درس: " :value="courses[key - 1].ID" />
              <app-row icon="calendar-alt" title="تاریخ امتحان: " :value="courses[key - 1].ExamDate" />
              <app-row icon="clock" title="ساعت امتحان: " :value="courses[key - 1].ExamTime" />
              <app-row icon="building" title="مكان امتحان: " :value="courses[key - 1].ExamLocation" />
              <app-row icon="chair" title="صندلی: " :value="courses[key - 1].ExamChairNo" />
              <app-row icon="users" title="گروه: " :value="courses[key - 1].ExamGroup" />
            </div>
          </v-card>
        </div>
      </template>
      <template v-else>
        <div style="margin: 20px; display: flex">
          <div class="cycle-info">
            <b>عنوان: </b>{{ exams[this.selectedCourse].Name }}
          </div>
          <div class="cycle-info">
            <b>بازه پرینت کارت: </b>{{ exams[this.selectedCourse].PrintRange }}
          </div>
          <div class="cycle-info">
            <v-btn class="grid" color="green white--text" style="float: left" rounded
              @click="callDownload(exams[selectedCourse].ID)">
              دریافت کارت ورود به جلسه
            </v-btn>
          </div>
        </div>
        <v-data-table :items="courses" :headers="courseHeaders" class="elevation-1" :disable-pagination="true"
          :hide-default-footer="true"></v-data-table>
      </template>
    </div>
  </div>
</template>

<script>
import Exam from "./Exam";
import DetailRow from "@/components/DetailRow";
import { downloadKartExam } from "@/api/cycle";
import { saveByteArray } from "@/utils/constants";

export default {
  components: {
    appExam: Exam,
    appRow: DetailRow,
  },
  data() {
    return {
      selectedCourse: -1,
      courseHeaders: [
        {
          text: "کد درس",
          value: "ID",
          width: "10%",
        },
        {
          text: "عنوان",
          value: "TitleName",
          width: "20%",
        },
        {
          text: "واحد",
          value: "Vahed",
          width: "10%",
        },
        {
          text: "پايه",
          value: "PayehName",
          width: "10%",
        },
        {
          text: "تاريخ امتحان",
          value: "ExamDate",
          width: "10%",
        },
        {
          text: "ساعت امتحان",
          value: "ExamTime",
          width: "10%",
        },
        {
          text: "صندلی",
          value: "ExamChairNo",
          width: "10%",
        },
        {
          text: "مكان امتحان",
          value: "ExamLocation",
          width: "10%",
        },
        {
          text: "گروه",
          value: "ExamGroup",
          width: "10%",
        },
      ],
    };
  },
  created() {
    if (this.$route.query.index) {
      this.$router.replace({
        query: {}
      })
    }
    this.$store.dispatch("getExams");
  },
  computed: {
    exams() {
      return this.$store.getters.exams;
    },
    courses() {
      return this.exams[this.selectedCourse].Courses;
    },
    showDetails() {
      return this.selectedCourse > -1;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  methods: {
    onClickClass(index) {
      if (!this.showDetails) {
        window.scrollTo(0, 0);

        this.$store.commit("SET_HEADER_TITLE", "جزییات دوره ها");
        this.$router.push({
          query: {

            index: index
          }
        });
      }
    },
    callDownload(index) {
      this.$store.commit("SET_PROGRESS_SHOW", true);
      downloadKartExam(index)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_PROGRESS_SHOW", false);
          if (data.Success) {
            saveByteArray(data.Array, data.fileName);
          } else {
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          }
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  },

  watch: {

    '$route'(to, from) {
      this.selectedCourse = this.$route.query.index ?? -1;

    }
  },
};
</script>
<style scoped>
.courses {
  top: 200px;
}

@media only screen and (max-width: 540px) {
  .courses {
    top: 250px;
  }
}

.cycle-info {
  float: right;
  padding: 0 20px;
  width: 50%;
}
</style>
